<template>
  
  <div class="font-euclid ">

    <div class="my-7 flex justify-center  align-middle content-center items-center  cursor-pointer w-full">
      <router-link to="/"><img src="../assets/images/medremindLogoNew.png" alt="logo" class="mx-auto md:mr-3 w-3/6 md:w-full sm:h-8"></router-link>
    </div>

    <div>
      <h1  class="text-black text-2xl font-medium font-euclid my-2"  > Log in to MedRemind</h1>
    </div>

    
    <div
      v-if="success"
      class=" border w-2/6 mx-auto bg-medalertBlue bg-opacity-10    text-black px-4 py-3 mt-4 rounded relative"
      role="alert">

          <!-- <strong class="font-bold mx-2">Thank you!</strong> -->
          <span class="">{{ success }}</span>
      </div>

      <div
      v-if="error"
      class=" border w-2/6  mx-auto bg-red  text-white px-4 py-3 mt-4 rounded relative"
      role="alert">

          <!-- <strong class="font-bold mx-2">Thank you!</strong> -->
          <span class="">{{ error }}</span>
      </div>



    <div class="bg-white text-black px-2 md:px-20 py-8 font-euclid flex flex-col justify-center mx-auto align-middle    content-center md:w-2/4">
    

        <form class="w-full" @submit.prevent="handleSubmit">

            
            <div class="flex flex-col text-start mx-11 mt-5 mb-2">
                <label class="font-medium text-base mb-2" for="">Email</label>
                <input v-model="email" type="email" required   class=" rounded-md form-control block px-3 py-3 text-base font-normal text-gray-700
                bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Email address " >
            </div>

            <div class="flex flex-col text-start mx-11 mt-5 mb-2 relative">
              <div class="flex justify-between">

                <label class="font-medium text-base mb-2" for="">Password</label>
                <div class="cursor-pointer text-xs font-semibold font-euclid">
                  <span  @click="showPassword = !showPassword">  <p v-if="showPassword"> HIDE </p> <p v-else>SHOW</p> </span>
                </div>

              </div>
                <input   v-model="password" required v-bind:type="[showPassword ? 'text' : 'password']"  class="  rounded-md form-control block px-3 py-3 text-base font-normal text-gray-700
                bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Password " >
            </div>
           

            <div class="mt-3 text-center flex justify-start  mx-11 ">
                <p class="text-base text-blue-600 hover:underline cursor-pointer">
                  <router-link to="/forgot-password" >Forgot your password?</router-link>
                </p>
            </div>


            <div class="mt-6 mx-11">
                <button type="submit" class="text-white bg-medalertBlue hover:bg-blueHover focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-lg w-full py-3 text-center mr-3 md:mr-0 dark:bg-purple dark:hover:bg-purple dark:focus:ring-purple font-euclid"><span v-if="!isLoading">Log in</span>
                <span v-if="isLoading">
                  <Loading />
                </span>
                </button>
            </div>
        </form>

        <div class="mt-5 text-center flex justify-start mx-auto ">
                <p class="text-md">
                  Don't have an account?
                   <router-link to="/register" ><span class="text-blue-600 hover:underline">
                    Sign up</span></router-link>
                </p>
        </div>

    </div>

  </div>

</template>



<script>

import { ref } from 'vue'
import Loading from "../components/Loading";
import {useStore} from 'vuex'
import {useRouter} from 'vue-router'
import axios from 'axios';

export default {

    components:{Loading},

    setup() {
    const email = ref('')
    const password = ref('')
    const error =ref(null)
    const isLoading = ref(false);
    const showPassword = ref(false);
    const success = ref(null);

    const store = useStore()
    const router = useRouter()



    const handleSubmit = async () => {
      try {
        isLoading.value = true;
        const response =  await store.dispatch('loginUser', { email: email.value, password: password.value
        });
        axios.defaults.headers.common['Authorization'] = store.state.token
        const client_details = await axios.get('/api/v1/account/me',)
            if(client_details){
              console.log(client_details.data.data)
              store.commit('setUser', client_details.data.data)
              console.log(client_details.data.data.role)
            } else {
              throw new Error('could not complete login')
              }

          success.value = "Login successful";
          error.value = null;

          setTimeout(() => {
          success.value = '';
          isLoading.value = false;

          if(store.state.user.role == 'SUPER_ADMIN'){
              router.push('/admin-dashboard')
          } else{
            router.push('/dashboard');
          }
          }, 3000);
          
        

      } catch(err) {
        isLoading.value = false;
        error.value = err.response?.data?.result?.message ?? "Login cannot be completed";
        console.log(error.value)

        setTimeout(() => {
          // error.value = null;
        }, 2000);
      }

    }


    return { 
    handleSubmit, 
    email, 
    password, 
    error, 
    success,
    isLoading,
    showPassword }
  }

}

</script>



<style>

</style>